import { useState, useEffect } from 'react';
import { Plus, X } from 'lucide-react';

export default function FaqItem(props) {
  const [isDetail, setIsDetail] = useState(false);

  return (
    <div className="py-6">
      <div className="flex items-center justify-between space-x-4 ">
        <p className="font-[poppins] text-sm sm:text-lg text-[#181D27] font-semibold leading-[1.2]">
          {props.question}
        </p>
        <button
          onClick={() => setIsDetail((prev) => !prev)}
          className="cursor-pointer"
        >
          {isDetail ? (
            <X className="text-[#092F7B] w-5 h-5 sm:w-6 sm:h-6" />
          ) : (
            <Plus className="text-[#092F7B] w-5 h-5 sm:w-6 sm:h-6" />
          )}
        </button>
      </div>

      {isDetail && (
        <div className="transition-all duration-500 ease-in-out">
          <p className="pt-4 font-[poppins] text-xs sm:text-sm text-[#717680] font-normal leading-[1.4]">
            {props.answer}
          </p>
        </div>
      )}
    </div>
  );
}
